import React from "react";
import PropTypes from "prop-types";
// Material imports
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
const Loading = ({
  classes,
  label,
  elevation
}) => {
  return /*#__PURE__*/React.createElement(Card, {
    className: classes.card,
    elevation: elevation
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.spinner
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.block
  }), /*#__PURE__*/React.createElement("div", {
    className: `${classes.block} ${classes.rect2}`
  }), /*#__PURE__*/React.createElement("div", {
    className: `${classes.block} ${classes.rect3}`
  }), /*#__PURE__*/React.createElement("div", {
    className: `${classes.block} ${classes.rect4}`
  }), /*#__PURE__*/React.createElement("div", {
    className: `${classes.block} ${classes.rect5}`
  })), /*#__PURE__*/React.createElement(Typography, null, label));
};
const styles = {
  card: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 50
  },
  spinner: {
    width: 50,
    height: 55,
    textAlign: "center",
    fontSize: 10,
    marginBottom: 20
  },
  block: {
    backgroundColor: "#0050FF",
    height: "100%",
    width: 6,
    display: "inline-block",
    padding: 1,
    margin: 1,
    animationName: "$loading-screen",
    animationDuration: "1.2s",
    animationIterationCount: "infinite",
    animationTimingFunction: "ease-in-out"
  },
  rect2: {
    animationDelay: "-1.1s"
  },
  rect3: {
    animationDelay: "-1s"
  },
  rect4: {
    animationDelay: "-0.9s"
  },
  rect5: {
    animationDelay: "-0.8s"
  },
  "@keyframes loading-screen": {
    "0%": {
      transform: "scaleY(0.4)"
    },
    "40%": {
      transform: "scaleY(0.4)"
    },
    "100%": {
      transform: "scaleY(0.4)"
    },
    "20%": {
      transform: "scaleY(1)"
    }
  }
};
export default withStyles(styles)(Loading);
Loading.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  elevation: PropTypes.number.isRequired
};
Loading.defaultProps = {
  elevation: 1
};